export default __webpack_public_path__ + "static/media/shop-finance-image.e60498ba.png";